import { render } from "./WitnessDetails.vue?vue&type=template&id=0e3f7c5b"
import script from "./WitnessDetails.vue?vue&type=script&lang=js"
export * from "./WitnessDetails.vue?vue&type=script&lang=js"

import "./WitnessDetails.vue?vue&type=style&index=0&id=0e3f7c5b&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__